import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import React, { useState } from "react";
export default function useDoModalInit() {
    var _useState = _sliced_to_array(useState({
        open: false,
        x: 0,
        y: 0,
        width: 460,
        height: 360,
        pin: false,
        mode: "normal",
        modalname: "apsuccess2"
    }), 2), modalConfirmCancel = _useState[0], setModalConfirmCancel = _useState[1];
    var _useState1 = _sliced_to_array(useState({
        open: false,
        x: 0,
        y: 0,
        width: 360,
        height: 320,
        pin: false,
        mode: "normal",
        modalname: "success"
    }), 2), modalSuccess = _useState1[0], setModalSuccess = _useState1[1];
    var _useState2 = _sliced_to_array(useState({
        open: false,
        x: 0,
        y: 0,
        width: 360,
        height: 320,
        pin: false,
        mode: "normal",
        modalname: "savesuccess2"
    }), 2), modalSaveSuccess = _useState2[0], setModalSaveSuccess = _useState2[1];
    var _useState3 = _sliced_to_array(useState({
        open: false,
        x: 0,
        y: 0,
        width: 580,
        height: 550,
        pin: false,
        mode: "normal",
        modalname: "apsuccess2"
    }), 2), modalDeliEndProcess = _useState3[0], setModalDeliEndProcess = _useState3[1];
    var _useState4 = _sliced_to_array(useState({
        open: false,
        x: 0,
        y: 0,
        width: 500,
        height: 400,
        pin: false,
        mode: "normal",
        modalname: "ready-to-delivery"
    }), 2), modalReadyToDeliProcess = _useState4[0], setModalReadyToDeliProcess = _useState4[1];
    var _useState5 = _sliced_to_array(useState({
        open: false,
        x: 0,
        y: 0,
        width: 460,
        height: 410,
        pin: false,
        mode: "normal",
        modalname: "apsuccess2"
    }), 2), modalNotApprove = _useState5[0], setModalNotApprove = _useState5[1];
    var _useState6 = _sliced_to_array(useState({
        open: false,
        x: 0,
        y: 0,
        width: 460,
        height: 310,
        pin: false,
        mode: "normal",
        modalname: "apsuccess2"
    }), 2), modalAlert = _useState6[0], setModalAlert = _useState6[1];
    return {
        modalConfirmCancel: modalConfirmCancel,
        setModalConfirmCancel: setModalConfirmCancel,
        modalSuccess: modalSuccess,
        setModalSuccess: setModalSuccess,
        modalSaveSuccess: modalSaveSuccess,
        setModalSaveSuccess: setModalSaveSuccess,
        modalDeliEndProcess: modalDeliEndProcess,
        setModalDeliEndProcess: setModalDeliEndProcess,
        modalNotApprove: modalNotApprove,
        setModalNotApprove: setModalNotApprove,
        modalAlert: modalAlert,
        setModalAlert: setModalAlert,
        modalReadyToDeliProcess: modalReadyToDeliProcess,
        setModalReadyToDeliProcess: setModalReadyToDeliProcess
    };
}
